import React from 'react';
import { useFirebase } from '../contexts/FirebaseContext';
import { auth } from '../firebase-config';

const FirebaseDebug = () => {
  const { user, loading, error, firebaseReady } = useFirebase();

  // Check Firebase config
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  };
  
  // Mask key values for security but show if they're present
  const maskedConfig = Object.entries(firebaseConfig).reduce((acc, [key, value]) => {
    acc[key] = value ? 'PRESENT' : 'MISSING';
    return acc;
  }, {});

  return (
    <div style={{ 
      position: 'fixed', 
      bottom: '20px', 
      right: '20px', 
      zIndex: 9999,
      background: '#f8f9fa',
      border: '1px solid #ddd',
      padding: '10px',
      borderRadius: '5px',
      maxWidth: '300px',
      fontSize: '12px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)'
    }}>
      <h5>Firebase Debug</h5>
      <div>Status: {loading ? 'Loading...' : (firebaseReady ? 'Ready' : 'Not Ready')}</div>
      {error && <div style={{ color: 'red' }}>Error: {error.message || String(error)}</div>}
      <div>Auth Instance: {auth ? 'Available' : 'Not Available'}</div>
      <div>User: {user ? `${user.email} (${user.uid})` : 'Not signed in'}</div>
      <div>Config Variables:</div>
      <pre style={{ fontSize: '10px', overflow: 'auto', maxHeight: '150px' }}>
        {JSON.stringify(maskedConfig, null, 2)}
      </pre>
      <button 
        onClick={() => window.location.reload()} 
        style={{
          padding: '5px 10px',
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
          fontSize: '10px'
        }}
      >
        Refresh
      </button>
    </div>
  );
};

export default FirebaseDebug;